module.exports = __webpack_public_path__ + "static/how-democracies-die-f8c261bce6babbd4bbb298a4b942c0c9.jpg";